import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { setCompoundTableState, setSidePanelWidth } from 'BMapsSrc/redux/projectState/access';
import { useColorSchemeInfo } from 'BMapsSrc/redux/prefs/access';
import { EventBroker } from 'BMapsSrc/eventbroker';
import { CompoundTable } from './CompoundTable';
import { SidePanelContainer } from '../info_display/SidePanel';

export function CompoundTableSidePanel({ open, handleClose }) {
    const tableId = 'compoundTable';
    const { columnVisibilityModel, sidePanelWidth } = useSelector(
        (state) => state.projectState.tableState[tableId]
    );
    const { textCss } = useColorSchemeInfo();

    const [width, setWidth] = useState(sidePanelWidth);
    const [resizing, setResizing] = useState(false);

    function onMouseDown(e) {
        e.preventDefault();
        e.stopPropagation();
        setResizing(true);
    }

    useEffect(() => {
        function onMouseUp() {
            setResizing(false);
            setSidePanelWidth(width, tableId);
            EventBroker.publish('resize');
        }
        function onMouseMove(e) {
            e.preventDefault();
            e.stopPropagation();
            const newWidth = e.clientX - 10;
            if (newWidth > 20) {
                setWidth(newWidth);
            }
        }
        if (resizing) {
            document.addEventListener('mouseup', onMouseUp);
            document.addEventListener('mousemove', onMouseMove);
            return () => {
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
            };
        }
        return undefined;
    }, [resizing]);

    return (
        <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
            <SidePanelContainer
                open={open}
                handleClose={handleClose}
                title="Compound Table"
                width={width}
                contentStyle={{
                    padding: '0.5rem',
                }}
            >
                <CompoundTable
                    useProteinProperties
                    useAdditionalProperties
                    toolBarId="CompoundSidePanelTable"
                    setColumnVisibilityModel={(visibilityModel) => {
                        setCompoundTableState({ columnVisibilityModel: visibilityModel });
                    }}
                    columnVisibilityModel={columnVisibilityModel}
                    tableId={tableId}
                />
            </SidePanelContainer>
            <div
                role="toolbar"
                onMouseDown={onMouseDown}
                style={{
                    cursor: 'ew-resize',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    marginRight: '.5rem',
                }}
            >
                <i className="fa fa-arrows-h" style={{ color: textCss }} />
            </div>
        </div>
    );
}
